import { Component } from "@angular/core";

@Component({
    selector: 'app-direccion-compra-desktop',
    templateUrl: './direccion-compra-desktop.component.html',
    styleUrls: ['./direccion-compra-desktop.component.scss'],
    standalone: false
})
export class direccionCompraDesktopComponent
{
    constructor(){}
}